var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusevkreis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sev-icon muc",
    transform: "scale(.5) translate(75 83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2274 0L0.000366211 68.0298L40.2274 136.06H120.672L160.895 68.0298L120.672 0",
    fill: "#91268F"
  }))), /*#__PURE__*/React.createElement("text", {
    style: {
      color: "black",
      fontFamily: "arial",
      fontSize: 30,
      fontWeight: "bold"
    },
    fill: "white",
    x: 47,
    y: 85
  }, "SEV"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusevkreis);
export default __webpack_public_path__ + "static/media/busevkreis.9a98c233b719b5ea076acfde65d84df2.svg";
export { ForwardRef as ReactComponent };